import {
  defaultSystemCode,
  exists,
  SystemCode,
  SystemCodeFromJSON
} from '@/api'
import { dateToPlainFormat } from '@/utils'

export interface DefaultParameterOrder {
  id: number
  systemUserId: number
  defaultType: string
  serial: number
  searchType: SystemCode
  configBranchCode: SystemCode
  orderDate: string
  traderEnvVendorId: number
  donorEnvVendorId: number
  buyDepartmentCode: SystemCode
  budgetYear: string
  budgetBranchCode: SystemCode
  budgetDepartmentCode: SystemCode
  budgetExpenseCode: SystemCode
  collectionType: SystemCode
  acceptType: SystemCode
  equipType: SystemCode
  defaultFlag: boolean
  revision: number
}

export function DefaultParameterOrderFromJSON(
  json: any
): DefaultParameterOrder {
  return {
    id: exists(json, 'id') ? json.id : 0,
    systemUserId: exists(json, 'system_user_id') ? json.system_user_id : 0,
    defaultType: exists(json, 'default_type') ? json.default_type : '',
    serial: exists(json, 'serial') ? json.serial : 0,
    searchType: exists(json, 'search_type')
      ? SystemCodeFromJSON(json.search_type)
      : defaultSystemCode(),
    configBranchCode: exists(json, 'config_branch_code')
      ? SystemCodeFromJSON(json.config_branch_code)
      : defaultSystemCode(),
    orderDate: exists(json, 'order_date')
      ? dateToPlainFormat(json.order_date)
      : '',
    traderEnvVendorId: exists(json, 'trader_env_vendor_id')
      ? json.trader_env_vendor_id
      : 0,
    donorEnvVendorId: exists(json, 'donor_env_vendor_id')
      ? json.donor_env_vendor_id
      : 0,
    buyDepartmentCode: exists(json, 'buy_department_code')
      ? SystemCodeFromJSON(json.buy_department_code)
      : defaultSystemCode(),
    budgetYear: exists(json, 'budget_year') ? json.budget_year : 0,
    budgetBranchCode: exists(json, 'budget_branch_code')
      ? SystemCodeFromJSON(json.budget_branch_code)
      : defaultSystemCode(),
    budgetDepartmentCode: exists(json, 'budget_department_code')
      ? SystemCodeFromJSON(json.budget_department_code)
      : defaultSystemCode(),
    budgetExpenseCode: exists(json, 'budget_expense_code')
      ? SystemCodeFromJSON(json.budget_expense_code)
      : defaultSystemCode(),
    collectionType: exists(json, 'collection_type')
      ? SystemCodeFromJSON(json.collection_type)
      : defaultSystemCode(),
    acceptType: exists(json, 'accept_type')
      ? SystemCodeFromJSON(json.accept_type)
      : defaultSystemCode(),
    equipType: exists(json, 'equip_type')
      ? SystemCodeFromJSON(json.equip_type)
      : defaultSystemCode(),
    defaultFlag: exists(json, 'default_flag') ? json.default_flag : false,
    revision: exists(json, 'revision') ? json.revision : 0
  }
}
